import React from 'react';
import { WithChildrenProps } from '..';
import AuditLabelContext, { AuditLabelController } from './AuditLabelContext';

interface AuditLabelProviderProps extends WithChildrenProps {
    
}

interface AuditLabelProviderState {
    resources: AuditLabelController
}

class AuditLabelProvider extends React.Component<AuditLabelProviderProps, AuditLabelProviderState> {

    constructor(props: AuditLabelProviderProps) {
        super(props);
        this.state = {
            resources: {}
        }
    }

    async getResource() {
        const response = await fetch(`audit.json?q=${Date.now()}`);
        const resources = await response.json();
        this.setState({ resources });
    }

    componentDidMount() {
        this.getResource();
    }

    render() {
        const { children } = this.props;
        const { resources } = this.state;
        return (
            <AuditLabelContext.Provider value={{ resources }}>
                {children}
            </AuditLabelContext.Provider>
        );
    }
}

export default AuditLabelProvider;